module.exports = __webpack_public_path__ + "media/images/logo-7-9b460e8ac53636323f070598cc6d197c.png";